import React, { useState, useEffect, useRef } from "react";

import { TextField, InputAdornment, FormLabel, FormControlLabel, FormControl, Tabs, Tab, FormGroup, Checkbox, Autocomplete } from '@mui/material';
import DollarIcon from '@mui/icons-material/AttachMoney';

import HoaLandScapingForm from './hoa-landscaping-form';
import HoaTrashForm from './hoa-trash-form';
import HoaParkingForm from './hoa-parking-form';
import HoaNuisanceForm from './hoa-nuisance-form';
import HoaStructureForm from "./hoa-structure-form";

import config from '../../../hoa-config';

import '../../hoa-styles.scss';
import '../../municipalities/hoa-municipality-styles.scss';
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import EditCancelConfirmationModal from "../../../shared-components/edit-cancel-confirmation";

interface HoaAViolationRegulationsFormProps {
    setViolationRegulations: any;
    height: number;
    selectedMunicipality: any;
    view: string;
    selectedValues: any;
    checkViolationWarning: any;
    state: any;
    setState: any;
    structureBuildingFiles: any;
    setStructureBuildingFiles: any;
}


export default function HoaAViolationRegulationsForm(props: HoaAViolationRegulationsFormProps) {
    const { setViolationRegulations, view, selectedValues, checkViolationWarning, state, setState, structureBuildingFiles, setStructureBuildingFiles } = props;
    const [tabIndex, setTabIndex] = useState(0);
    const [isWaring, setIsWarning] = useState(false);
    const [checkBoxField, setCheckBoxField] = useState('');
    const { isViolationRegulationFieldDisabled } = useFieldDisabled();

    const tabTitles = ["Landscaping", "Trash", "Parking", "Nuisance", "Structure", "Others"];

    const handleChange = (value: any, key: string, checkOptions?:boolean) => {
        let tempState: any = { ...state };
        checkViolationWarning(tempState);
        if(value == null){
            value = "";
        }
        if(key === 'notificationType') {
            let results = tempState['notificationType'] || '';
            if(checkOptions){
                results = results + value;
            } else {
                results = results.replace(value,'')
            }
            tempState[key] = results;
        } else {
            tempState[key] = value;
        }
        setState(tempState);
        setViolationRegulations(tempState);
    }

    const wheel =(e: any) => {
        e.target.blur();
    }

    const handleCheckbox = (field: string, key: string, isChecked: boolean, value: string) => {
        let tempState: any = { ...state };
        if (!isChecked && value) {
            setCheckBoxField(field);
            setIsWarning(!isWaring);
        } else if (isChecked && !value) {
            tempState[key].push(field);
        } else {
            tempState.preferredViolationRemediation = tempState[key].filter((item: any) => item !== field)
        }
        setState(tempState);
        setViolationRegulations(tempState);
    }

    const unCheckWarningYesClick = () => {
        let tempState: any = { ...state };
        tempState.preferredViolationRemediation = tempState['preferredViolationRemediation'].filter((item: any) => item !== checkBoxField)
        if(checkBoxField && config.preferredViolationRemediation[checkBoxField]){
            tempState[config.preferredViolationRemediation[checkBoxField]] = '';
        }
        setState(tempState);
        setViolationRegulations(tempState);
        setIsWarning(false);
    }

    return (
        <div style={{ width: "100%", height: props.height, overflowY: 'scroll', borderRadius: "4px", fontSize: '20px' }} className="add-municipality-form-container">
            <div className="left-form-container" style={{ width: "35%" }}>
                <div className="sub-title-text">Basic Information</div>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                    <TextField 
                        variant="standard" 
                        style={{ width: "100%", height: '64px', boxSizing: "border-box", marginBottom: "12px" }} 
                        value={state.minViolationFees} 
                        type='number' 
                        onWheel={e => wheel(e)}
                        onChange={(e) => { handleChange(e.target.value, "minViolationFees") }} 
                        label="Violation Fees (min)" 
                        InputLabelProps={{ style: { fontSize: "14px", margin: "auto 4px" } }}
                        disabled={isViolationRegulationFieldDisabled('minViolationFees')}
                        InputProps={{
                            style: { padding: "7px 0px" },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <DollarIcon />
                                </InputAdornment>
                            )
                        }} />
                </div>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                    <TextField 
                        variant="standard" 
                        style={{ width: "100%", height: '64px', boxSizing: "border-box", marginBottom: "12px" }} 
                        value={state.maxViolationFees} 
                        type='number' 
                        onWheel={e => wheel(e)}
                        onChange={(e) => { handleChange(e.target.value, "maxViolationFees") }} 
                        label="Violation Fees (max)" 
                        InputLabelProps={{ style: { fontSize: "14px", margin: "auto 4px" } }}
                        disabled={isViolationRegulationFieldDisabled('maxViolationFees')}
                        InputProps={{
                            style: { padding: "7px 0px" },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <DollarIcon />
                                </InputAdornment>
                            )
                    }} />
                </div>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                    <TextField 
                        style={{ width: "50%", marginRight: "10px", height: '64px' }} 
                        variant="standard" 
                        label="Cure Period" 
                        value={state.curePeriod} 
                        type='number' 
                        onWheel={e => wheel(e)}
                        onChange={(e) => { handleChange(e.target.value, "curePeriod") }} 
                        InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }} 
                        disabled={isViolationRegulationFieldDisabled('curePeriod')}
                    />
                    <Autocomplete
                        ListboxProps={{ style: { maxHeight: "200px"} }}
                        style={{ width: "50%", height:"62px", boxSizing:"border-box"}}
                        disablePortal
                        value={state.timeline ? state.timeline : ''}
                        options={config.timeLines}
                        onChange={(e, v) => {
                            handleChange(v, "timeline")
                        }}
                        disabled={isViolationRegulationFieldDisabled('timeline')}
                        renderInput={(params: any) => 
                            <TextField 
                                variant="standard" 
                                style={{height:"100%"}} 
                                {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} 
                                label="Timeline"
                            />}
                    />
                </div>

                <TextField 
                    style={{ width: "100%" }} 
                    variant="standard" 
                    label="Violation Payment" 
                    value={state.violationPayment}
                    onChange={(e) => { handleChange(e.target.value, "violationPayment") }} 
                    InputLabelProps={{ style: { fontSize: "14px" } }}
                    InputProps={{ style: { padding: "7px 0px" } }} 
                    disabled={isViolationRegulationFieldDisabled('violationPayment')}
                />
                
                <FormControl style={{ width: "90%", margin:'14px'}} component="fieldset" variant="standard" >
                    <FormLabel style={{ fontSize:'12px', marginBottom: "7px"}} component="legend">Notification Type</FormLabel>
                        <FormGroup style={{ display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                        <FormControlLabel
                            style={{ fontSize:'10px'}}
                            control={
                                <Checkbox 
                                    checked={state.notificationType.includes('Written Notice')} 
                                    onChange={(event) => handleChange('Written Notice', "notificationType",event.target.checked)}
                                    disabled={isViolationRegulationFieldDisabled('notificationType')}
                                />
                            }
                            label="Written Notice"
                        />
                        <FormControlLabel
                            style={{ fontSize:'10px'}}
                            control={
                                <Checkbox 
                                    checked={state.notificationType.includes('Email')} 
                                    onChange={(event) => handleChange('Email', "notificationType",event.target.checked)} 
                                    disabled={isViolationRegulationFieldDisabled('notificationType')}
                                />
                            }
                            label="Email"
                        />
                    </FormGroup>
                </FormControl>
                <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                    <FormLabel component="legend">Preferred Violation Remediation</FormLabel>
                    <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={state.preferredViolationRemediation.includes('Portal')} 
                                onChange={(event) => handleCheckbox('Portal', 'preferredViolationRemediation', event.target.checked, state.additionalInfoOfPortal)} 
                                disabled={isViolationRegulationFieldDisabled('preferredViolationRemediation') || isViolationRegulationFieldDisabled('additionalInfoOfPortal')}
                            />
                        }
                        label="Portal"
                    />
                    {
                        state.preferredViolationRemediation.includes('Portal') && (
                            <TextField 
                                style={{ marginLeft: '32px', width: '100%' }} 
                                variant="standard" 
                                multiline 
                                label="Additional Information" 
                                value={state.additionalInfoOfPortal}
                                onChange={(e) => { handleChange(e.target.value, 'additionalInfoOfPortal') }} 
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }}
                                disabled={isViolationRegulationFieldDisabled('additionalInfoOfPortal')}
                            />
                        )
                    }
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={state.preferredViolationRemediation.includes('Email')} 
                                onChange={(event) => handleCheckbox('Email', 'preferredViolationRemediation', event.target.checked, state.additionalInfoOfEmail)} 
                                disabled={isViolationRegulationFieldDisabled('preferredViolationRemediation') || isViolationRegulationFieldDisabled('additionalInfoOfEmail')}
                            />
                        }
                        label="Email"
                    />
                    {
                        state.preferredViolationRemediation.includes('Email') && (
                            <TextField 
                                style={{ marginLeft: '32px', width: '100%' }} 
                                variant="standard" 
                                multiline 
                                label="Additional Information" 
                                value={state.additionalInfoOfEmail}
                                onChange={(e) => { handleChange(e.target.value, 'additionalInfoOfEmail') }} 
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }} 
                                disabled={isViolationRegulationFieldDisabled('additionalInfoOfEmail')}
                            />
                        )
                    }
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={state.preferredViolationRemediation.includes('Other')} 
                                onChange={(event) => handleCheckbox('Other', 'preferredViolationRemediation', event.target.checked, state.additionalInfoOfOther)} 
                                disabled={isViolationRegulationFieldDisabled('preferredViolationRemediation') || isViolationRegulationFieldDisabled('additionalInfoOfOther')}
                            />
                        }
                        label="Other"
                    />
                    {
                        state.preferredViolationRemediation.includes('Other') && (
                            <TextField 
                                style={{ marginLeft: '32px', width: '100%' }} 
                                variant="standard" 
                                multiline 
                                label="Additional Information" 
                                value={state.additionalInfoOfOther}
                                onChange={(e) => { handleChange(e.target.value, 'additionalInfoOfOther') }} 
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }} 
                                disabled={isViolationRegulationFieldDisabled('additionalInfoOfOther')}
                            />
                        )
                    }
                    </FormGroup>
                </FormControl>

                <div style={{margin: '12px 0px'}} className="sub-title-text">Other Restrictions in Place and Fees</div>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                    <TextField 
                        style={{ width: "50%", marginRight: "10px", height: '64px' }} 
                        variant="standard" 
                        label="Grace Period" 
                        value={state.gracePeriod} 
                        type='number' 
                        onWheel={e => wheel(e)}
                        onChange={(e) => { handleChange(e.target.value, "gracePeriod") }} 
                        InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }} 
                        disabled={isViolationRegulationFieldDisabled('gracePeriod')}
                    />
                    <Autocomplete
                        ListboxProps={{ style: { maxHeight: "200px"} }}
                        style={{ width: "50%", height:"62px", boxSizing:"border-box"}}
                        disablePortal
                        value={state.graceTimeline ? state.graceTimeline : ''}
                        options={config.timeLines}
                        onChange={(e, v) => {
                            handleChange(v, "graceTimeline")
                        }}
                        disabled={isViolationRegulationFieldDisabled('graceTimeline')}
                        renderInput={(params: any) => 
                            <TextField 
                                variant="standard" 
                                style={{height:"100%"}} 
                                {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} 
                                label="Timeline"
                            />
                        }
                    />
                </div>
                <div>
                    <div style={{margin:"12px 0px", fontSize:"14px"}}>Assessment Fee</div>
                    <TextField 
                        style={{ width: "100%", marginBottom:"24px"}} 
                        variant="outlined" 
                        value={state.assessmentFee}
                        onChange={(e) => { handleChange(e.target.value, "assessmentFee") }} 
                        label="Write here..." 
                        multiline
                        InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} 
                        InputProps={{ style: { minHeight:"106px" } }}
                        disabled={isViolationRegulationFieldDisabled('assessmentFee')}
                    />
                </div>
                <div>
                    <div style={{margin:"12px 0px", fontSize:"14px"}}>Assessment Violation Fee</div>
                    <TextField 
                        style={{ width: "100%", marginBottom:"24px"}} 
                        variant="outlined" 
                        value={state.assessmentViolationFee}
                        onChange={(e) => { handleChange(e.target.value, "assessmentViolationFee") }} 
                        label="Write here..." 
                        multiline
                        InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} 
                        InputProps={{ style: { minHeight:"106px" } }}
                        disabled={isViolationRegulationFieldDisabled('assessmentViolationFee')}
                    />
                </div>
                <TextField 
                    style={{ width: "100%" }} 
                    multiline 
                    variant="standard" 
                    label="Additional Information" 
                    value={state.assessmentViolationFeeAdditionalInfo}
                    onChange={(e) => { handleChange(e.target.value, "assessmentViolationFeeAdditionalInfo") }} 
                    InputLabelProps={{ style: { fontSize: "14px" } }}
                    InputProps={{ style: { padding: "7px 0px" } }} 
                    disabled={isViolationRegulationFieldDisabled('assessmentViolationFeeAdditionalInfo')}
                />

                <Autocomplete
                    ListboxProps={{ style: { maxHeight: "200px"} }}
                    style={{ width: "100%", height:"54px", boxSizing:"border-box", marginTop: '24px', fontSize: "14px"}}
                    disablePortal
                    value={state.assessmentFrequency ? state.assessmentFrequency : ''}
                    options={config.frequencyOptions}
                    onChange={(e, v) => {
                        handleChange(v, "assessmentFrequency")
                    }}
                    disabled={isViolationRegulationFieldDisabled('assessmentFrequency')}
                    renderInput={(params: any) => 
                        <TextField 
                            variant="standard" 
                            style={{height:"100%", paddingBottom: '24px'}} 
                            {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} 
                            label="Assessment Frequency"
                        />
                    }
                />
            </div>
            {/*RIGHT*/}
            <div className="right-form-container" style={{width:"65%"}}>
                <div>
                    <Tabs
                        value={tabIndex}
                        onChange={(event, value) => {
                            setTabIndex(value);
                        }}
                        style={{ width:"100%" }}
                    >
                        {tabTitles.map((title: string, index: number) => {
                            return (
                                <Tab
                                    key={index}
                                    label={title}
                                    value={index}
                                    style={{ padding:"5px 10px", textTransform: "none" }}
                                />
                            );
                        })}
                    </Tabs>
                </div>
                <div style={{ marginTop: "25px" }}>
                {
                    tabIndex === 0 ?
                    <HoaLandScapingForm handleChange={handleChange} values = {state.landscaping}/>
                    : tabIndex === 1 ?
                    <HoaTrashForm handleChange={handleChange} values = {state.trash}/>
                    : tabIndex === 2 ?
                    <HoaParkingForm handleChange={handleChange} values = {state.parking}/>
                    : tabIndex === 3 ?
                    <HoaNuisanceForm handleChange={handleChange} values = {state.nuisance}/>
                    : tabIndex === 4 ?
                        <HoaStructureForm 
                            handleChange={handleChange} 
                            values = {state.structure} 
                            view={view} 
                            setViolationRegulations={setViolationRegulations} 
                            structureBuildingFiles={structureBuildingFiles} 
                            setStructureBuildingFiles={setStructureBuildingFiles}
                        />
                    : tabIndex === 5 ?
                    <div>
                        <div style={{margin:"12px 0px", fontSize:"12px"}}>Please write down if there are any other restrictions for the HOA.</div>
                        <TextField 
                            style={{ width: "75%", marginBottom:"24px"}} 
                            variant="outlined" 
                            value={state.others}
                            onChange={(e) => { handleChange(e.target.value, "others") }} 
                            label="Write here..." 
                            multiline
                            InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} 
                            InputProps={{ style: { minHeight:"106px" } }}
                            disabled={isViolationRegulationFieldDisabled('others')}
                        />
                    </div>
                    : ''
                }
                </div>

            </div>

            <EditCancelConfirmationModal 
                label="Are you sure you want to deselect? Regulation texts will be discarded if you confirm."
                isCancelClicked={isWaring}
                setIsCancelClicked={setIsWarning}
                onCancelYesClick={unCheckWarningYesClick}
            />
        </div>
    )
}